// Backend er kilde til sandhed. Disse bruges som fallback hvis
// /admin/rettigheder-kald fejler eller før det er hentet.
export const RETTIGHEDER_FALLBACK = [
  { id: "kan_se_vagtplan", label: "Vagtplan", beskrivelse: "Se, oprette og ændre vagter" },
  { id: "kan_se_elever", label: "Elev-stamkort (se)", beskrivelse: "Se ALT på elev-stamkortet (read-only)" },
  { id: "kan_redigere_elever", label: "Elev-stamkort (rediger)", beskrivelse: "Fuld adgang til elev-stamkortet — stamdata, karakterer, dokumenter, timer, alt" },
  { id: "kan_se_medarbejdere", label: "Medarbejdere", beskrivelse: "Se medarbejder (kun stamdata)" },
  { id: "kan_godkende_kalender", label: "Godkend kalender", beskrivelse: "Godkend kalender-events" },
  { id: "kan_godkende_stempling", label: "Godkend stempling", beskrivelse: "Godkend stempling og timer" },
  { id: "kan_godkende_koersel", label: "Godkend kørsel", beskrivelse: "Se, godkende, afvise og eksportere kørselsregistreringer" },
  { id: "kan_uploade_undervisningsmateriale", label: "Undervisning", beskrivelse: "Upload undervisningsmateriale" },
  { id: "kan_se_fortrolige_medarbejderoplysninger", label: "Fortrolige medarbejderoplysninger", beskrivelse: "Se løn, pension, kontrakter, feriebank for alle medarbejdere" },
];

// Rettigheder Admin har som default. Fortrolige medarbejderoplysninger er opt-in
// og IKKE i baseline — den skal tildeles eksplicit.
export const ADMIN_BASELINE_FALLBACK = [
  "kan_se_vagtplan",
  "kan_se_elever",
  "kan_redigere_elever",
  "kan_se_medarbejdere",
  "kan_godkende_kalender",
  "kan_godkende_stempling",
];

// Rettigheder der IKKE auto-tildeles via rolle — kræver eksplicit tildeling
// for både admin og members. Bruges af RettighedsEditor til at vise opt-in-flow
// (bekræftelsesdialog ved tildeling).
export const OPT_IN_RETTIGHEDER = [
  "kan_se_fortrolige_medarbejderoplysninger",
];

// Returnér label for en rettighed-id (legacy-array-format mappes til nye id'er)
const LEGACY_MAP = {
  "vagtplan": "kan_se_vagtplan",
  "kalender_godkend": "kan_godkende_kalender",
  "elev_stamkort": "kan_se_elever",
  "medarbejder_okonomi": "kan_se_medarbejdere",
};

export function rettighedId(raw) {
  return LEGACY_MAP[raw] || raw;
}

// Kanonisk by-liste til Vagtplan-rettighedens by-filter.
export const VAGTPLAN_BYER = ["København", "Aarhus", "Odense", "Aalborg", "Kolding", "Administration", "TNBC"];

// Nøgle hvorunder de tilladte byer for kan_se_vagtplan gemmes (parameter ved
// siden af selve boolean-toggle'en). [] eller mangler = ALLE byer.
export const VAGTPLAN_BYER_KEY = "kan_se_vagtplan__byer";

// Konvertér rettigheder fra DB (array eller dict) til ensartet dict { id: bool }.
// Parameter-nøgler (med "__", fx kan_se_vagtplan__byer) er IKKE booleans og
// springes over her — læs dem med rettighedParam().
export function rettighederTilDict(raw) {
  const out = {};
  if (Array.isArray(raw)) {
    raw.forEach(id => { out[rettighedId(id)] = true; });
  } else if (raw && typeof raw === "object") {
    Object.keys(raw).forEach(k => {
      if (k.includes("__")) return; // parameter, ikke boolean toggle
      out[rettighedId(k)] = !!raw[k];
    });
  }
  return out;
}

// Læs en parameter-værdi (fx tilladte byer) fra rå rettigheder.
export function rettighedParam(raw, key) {
  if (raw && typeof raw === "object" && !Array.isArray(raw)) return raw[key];
  return undefined;
}

// Tilladte byer for kan_se_vagtplan. Returnerer array (tom = alle byer).
export function vagtplanByer(raw) {
  const v = rettighedParam(raw, VAGTPLAN_BYER_KEY);
  return Array.isArray(v) ? v.filter(Boolean) : [];
}

// Alias til vagtplanByer — læs de tilladte afdelinger fra et rettigheds-dict.
// Tom liste / mangler = ALLE afdelinger (ingen begrænsning, fuld adgang).
export function getVagtplanByer(dict) {
  return vagtplanByer(dict);
}

// Returnér et NYT dict med tilladte vagtplan-afdelinger sat.
// byerArray tom (eller ej-array) => fjern nøglen helt (= alle afdelinger).
// byerArray ikke-tom => gem den rensede liste under VAGTPLAN_BYER_KEY.
// Backend (_vagtplan_tilladte_byer) honorerer dette: tom/mangler => None (alle).
export function setVagtplanByer(dict, byerArray) {
  const base = dict && typeof dict === "object" && !Array.isArray(dict) ? dict : {};
  const out = { ...base };
  const rene = Array.isArray(byerArray)
    ? [...new Set(byerArray.map(b => String(b).trim()).filter(Boolean))]
    : [];
  if (rene.length) out[VAGTPLAN_BYER_KEY] = rene;
  else delete out[VAGTPLAN_BYER_KEY];
  return out;
}

// Aktive IDs (kun dem med true)
export function aktiveRettigheder(raw) {
  const d = rettighederTilDict(raw);
  return Object.keys(d).filter(k => d[k]);
}
